import React, { ReactNode } from 'react';
import c from 'classnames';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import type { FileField } from '@uncinc/react-drupal-core/types';

import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';
import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../config/constants';

import './style.scss';

type HeroProps = {
  image?: MediaReferenceField<'image'> | null;
  video?: MediaReferenceField<'video_file'> | null;
  mobileVideo?: FileField | null;
  className?: string;
  imageStyles?: { [key: string]: string } | null;
  children: ReactNode;
};

const Hero = ({
  image = null,
  video = null,
  mobileVideo = null,
  className = '',
  imageStyles = null,
  children,
}: HeroProps) => {
  const classes = c(className, 'Hero');
  const imageStyleSrc = imageStyles ?? {
    [SCREEN_MOBILE]: image?.styles?.ratio_3_4_md,
    [SCREEN_TABLET]: image?.styles?.ratio_4_3_xl,
    [SCREEN_NORMAL]: image?.styles?.ratio_2_1_xl,
    [SCREEN_WIDE]: image?.styles?.ratio_2_1_xl,
  };

  return (
    <div className={classes}>

      <div className="Hero__wrapper">
        {image && (
          <Image
            src={imageStyleSrc}
            lazyload={false}
            alt={image.alt}
          />
        )}
        {video && !mobileVideo && (
          <video id="hero-video" className="Hero__video" controls={false} muted loop playsInline autoPlay>
            <source src={video.source} type="video/mp4" />
          </video>
        )}
        {!video && mobileVideo && (
          <video id="hero-video" className="Hero__mobileVideo" controls={false} muted loop playsInline autoPlay>
            <source src={mobileVideo.source} type="video/mp4" />
          </video>
        )}

        <div className="Hero__wrapper__content">
          <div className="Hero__wrapper__content__inner">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
